import * as moment from 'moment'


export default class DateUtils {
  monthList = ['Jan', 'Feb', 'March', 'April', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
  formatDate(date: string) {
    const d = date.split(" ");
    return `${d[1]} ${d[2]}, ${d[d.length - 1]}`;
  }
  getShortDate(date) {
    return new Date(date).toJSON().split('T')[0];
  }
  getDefReportDateRange(value?): {startDate: string, endDate: string} {
    const stz = this.getTsByNum(value || 30);
    const startDate = this.getShortDate(stz || this.getPrvMntTs());
    const endDate = this.getShortDate(new Date());
    return {startDate, endDate}
  }
  getYears(): any[] {
    const yearValue = [];
    var fullYear = new Date().getFullYear();
    var i;
    for (i = 2016; i <= fullYear; i++) {
      const info = i;
      yearValue.push({year_value: info })
    }
    return yearValue;
  }
  getQuarterlyData(months) {
    const quatersLabel = ['Q1', 'Q2', 'Q3', 'Q4'];
    const quarters = {1: 0, 2: 0, 3: 0, 4: 0};
    Object.keys(months).forEach((m: any) => {
      const q = this.getQuarter(m)
      let count = quarters[q];
      if(count || count === 0) {
        count = months[m] + count
      }
      quarters[q] = count;
    });
    let result = [];
    Object.values(quarters).forEach(q => result.push(q));
    return {quatersLabel, quarters: result, quartersObj: quarters};
  }
  getQuarter(month: number) {
    let quater = 1
    if(month <= 2) {
      quater = 1
    } else if(month <= 5) {
      quater = 2
    } else if(month <= 8) {
      quater = 3
    } else if(month <= 11) {
      quater = 4
    }
    return quater;
  }
  getYearToDateRange(yr: number): {startDate:any, endDate: any} {
    const startDate = new Date(yr, 0).getTime();
    const endDate = this.getEndTimeStp(new Date(yr, 11, 31));
    return {startDate, endDate}
  }

  getTimeStp(date) {
    if(!date) return date
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d.getTime();
  }
  getDtPikerTimeStp = (date) => {
    const d = new Date(Number(date))
    return d.getTime();
  }
  getEndTimeStp(date) {
    const d = new Date(date);
    d.setHours(23, 59);
    return d.getTime();
  }
  getResetDatesTime(date) {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d.toJSON();
  }
  getCurrentTs() {
    return new Date().getTime();
  }
  getPrvMntTs() {
    return new Date().setMonth(new Date().getMonth() - 6).valueOf();
  }
  getLstMntTs() {
    return new Date().setMonth(new Date().getMonth() - 1).valueOf();
  }
  getLstMntDate() {
    return new Date(new Date().setMonth(new Date().getMonth() - 1));
  }
  getInitDate(): { startDate: any; endDate: any } {
    return { startDate: this.getPrvMntTs(), endDate: this.getCurrentTs() };
  }
  getNxtMntTs() {
    return new Date().setMonth(new Date().getMonth() + 1).valueOf();
  }
  getNxtDayTs(date) {
    return new Date(date).setDate(new Date(date).getDate() + 1).valueOf();
  }
  getNxtDay() {
    return new Date(new Date().setDate(new Date().getDate() + 1))
  }
  getTsByNum(value: number) { 
    // if(!value) return value
    const d = new Date(new Date().setDate(new Date().getDate() - value));
    d.setHours(0, 0, 0, 0);
    return d.getTime();
    // return new Date(new Date().setDate(new Date().getDate() - value)).valueOf()
  }
  getTicketDateRange(date: {startDate: any}) {
      const startDate = this.getTimeStp(moment(date.startDate).subtract(3, 'M').format());
      const endDate = this.getEndTimeStp(moment(date.startDate).add(3, 'M').format());
      return { startDate, endDate}
  }
  getDateFilter(dateFilter: { endDate: any; startDate: any }): { endDate: any; startDate: any } {
    let newFilter = {
      endDate:
        dateFilter && dateFilter.endDate
          ? this.getEndTimeStp(dateFilter.endDate)
          : this.getTimeStp(this.getNxtDay()),
      startDate:
        dateFilter && dateFilter.startDate
          ? this.getTimeStp(dateFilter.startDate)
          : this.getTimeStp(this.getLstMntDate()),
    };
    if (newFilter.endDate === newFilter.startDate) {
      newFilter.endDate = this.getNxtDayTs(newFilter.endDate);
    }
    return newFilter;
  }

  getDateFilterSalesOrder(dateFilter: { endDate: any; startDate: any }): { endDate: any; startDate: any } {
    let newFilter = {
      endDate:
        dateFilter && dateFilter.endDate
          ? this.getEndTimeStp(dateFilter.endDate)
          : this.getTimeStp(this.getNxtDay()),
      startDate:
        dateFilter && dateFilter.startDate
          ? this.getTimeStp(dateFilter.startDate)
          : this.getPrvMntTs(),
    };
    if (newFilter.endDate === newFilter.startDate) {
      newFilter.endDate = this.getNxtDayTs(newFilter.endDate);
    }
    return newFilter;
  }
  
  getDefaultDateRange(): { endDate: any; startDate: any } {
    return {endDate: new Date(this.getTimeStp(this.getNxtDay())), startDate: new Date(this.getPrvMntTs())}
  }

  padFigure(num) {
    return num.toString().length == 1 ? `0${num}` : num;
  } 

  checkIfDateIsInTimeStampFormat(input_date: string): boolean {
    const input_date_as_number: any = Number(input_date);
    return !isNaN(input_date_as_number);
  }

  convertDateToTimestamp(date: string) {
    if (this.checkIfDateIsInTimeStampFormat(date)) {
      return date;
    }
    return typeof date == "string" && date.length > 0
      ? Date.parse(date).toString()
      : "";
  }

  convertTimestampToDate(seconds) {
    const date = new Date(Number(seconds));
    let month = this.padFigure(date.getMonth() + 1),
      day = this.padFigure(date.getDate()),
      year = date.getFullYear();
 
    return seconds == 0 ? "" : `${day}/${month}/${year}`;;
  }

  getMaximumDateForHTMLDateInput(timestamp?) {
    const milli_seconds = timestamp || Date.now();
    return this.convertTimestampToDate(milli_seconds);
  }

  getCurrentDateTimestampInSeconds() {
    return Math.floor(Date.now() / 1000);
  }

  getCurrentDayInSeconds() {
    const date = new Date(Date.now());
    const year = date.getFullYear();
    const month = this.padFigure(date.getMonth() + 1);
    const day = this.padFigure(date.getDate());
    return Date.parse(`${year}-${month}-${day}`);
  }

  convertDateStringToTimestamp(date_string) {
    const d = new Date(date_string);
    const year = d.getFullYear();
    const month = d.getMonth() + 1;
    const day = d.getDate();
    const formatted_date = `${year}-${month}-${day}`;
    return Date.parse(formatted_date)
  }
  convertDatesToTsInObj(payload: object): any {
    let result = {}
    Object.keys(payload).forEach(field => {
      let fieldx = field.toLowerCase();
      if(fieldx.includes('startdate')) {
        result[field] = this.getTimeStp(payload[field])
      } else if(fieldx.includes('enddate')) {
        result[field] = this.getEndTimeStp(payload[field])
      } else {
        result[field] = payload[field]
      }
    })
    return result;
  }
  convertTstoDateInObj(payload: object): any {
    let result = {}
    Object.keys(payload).forEach(field => {
      if(field.includes('Date') && payload[field]){
        result[field] = new Date(payload[field])
      } else {
        result[field] = payload[field]
      }
    })
    return result;
  }
  formatDateToTs(value: string, format = 'mm/dd/yyyy') {
    let result = value;
    if(format==='mm/dd/yyyy') {
      const date = value.split(' ')[0].split('/');
      result = `${date[1]}/${date[0]}/${date[2]}`;
    }
    return new Date(result).getTime();
  }
  TimeStToDays(prev, curr=new Date().getTime()) { 
    var ms_Min = 60 * 1000; // milliseconds in Minute 
    var ms_Hour = ms_Min * 60; // milliseconds in Hour 
    var ms_Day = ms_Hour * 24; // milliseconds in day 
    var ms_Mon = ms_Day * 30; // milliseconds in Month 
    var ms_Yr = ms_Day * 365; // milliseconds in Year 
    var diff = curr - prev; //difference between dates. 
    // If the diff is less then milliseconds in a minute 

    if (diff < ms_Day) { 
      return 0; 
    } else {
      return Math.round(diff / ms_Day); 
    }
    // if (diff < ms_Min) { 
    //     return Math.round(diff / 1000) + ' seconds ago'; 
    // } else if (diff < ms_Hour) { 
    //     return Math.round(diff / ms_Min) + ' minutes ago'; 
    // } else if (diff < ms_Day) { 
    //     return Math.round(diff / ms_Hour) + ' hours ago'; 
    // } else {
    //   return 'Around ' + Math.round(diff / ms_Day) + ' days ago'; 
    // }
    // else if (diff < ms_Mon) { 
    //     return 'Around ' + Math.round(diff / ms_Day) + ' days ago'; 

    //     // If the diff is less then milliseconds in a year 
    // } else if (diff < ms_Yr) { 
    //     return 'Around ' + Math.round(diff / ms_Mon) + ' months ago'; 
    // } else { 
    //     return 'Around ' + Math.round(diff / ms_Yr) + ' years ago'; 
    // } 
} 

}
